import { Stethoscope, ArrowUpRight } from "lucide-react";

const SOCIALS = ["Instagram", "LinkedIn", "Behance", "TikTok"];
const NAV = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "Studio", href: "#studio" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-dm-dark text-white grain overflow-hidden">
      <div className="relative z-10 mx-auto max-w-[1500px] px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="grid place-items-center h-9 w-9 rounded-full" style={{ background: "var(--dm-maroon)" }}>
                <Stethoscope size={18} className="text-white" strokeWidth={2.2} />
              </span>
              <span className="font-display text-xl font-extrabold tracking-tight">
                <span className="text-white">doctor</span>
                <span style={{ color: "var(--dm-maroonbright)" }}>.media</span>
              </span>
            </div>
            <p className="mt-5 max-w-xs text-white/55 leading-relaxed">
              Creative marketing &amp; design studio. Building brands worth
              remembering across Iraq, UAE &amp; Jordan.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <span className="overline text-[11px] text-white/40">Navigate</span>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-white/75 hover:text-white transition-colors font-display text-lg">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="overline text-[11px] text-white/40">Social</span>
            <ul className="mt-5 space-y-3">
              {SOCIALS.map((s) => (
                <li key={s}>
                  <a href="#top" className="group inline-flex items-center gap-1 text-white/75 hover:text-white transition-colors font-display text-lg">
                    {s}
                    <ArrowUpRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-white/40 text-sm font-oswald uppercase tracking-wide">
          <span>© {new Date().getFullYear()} Doctor Media. All rights reserved.</span>
          <span>Baghdad · Dubai · Amman</span>
        </div>
      </div>
    </footer>
  );
}
